import React from 'react';
import {Divider, Drawer as AntDrawer, Flex} from 'antd';
import {XCircleIcon} from '@phosphor-icons/react';
import {useCurrentUser} from "../../../../contexts/UserContext";
import {useViewerStore} from "../../../../store/store";
import UserInfoSection from './Drawer-Sections/1-User-Info-Section/UserInfoSection';
import AddressInfoSection from "./Drawer-Sections/2-Address-Info-Section/AddressInfoSection";
import DesignList from "./Drawer-Sections/3-Design-Versioning-Section/DesignList";
import CertificationSection from "./Drawer-Sections/4-Design-Certification-Section/Certification-Section";
import ReportsSection from "./Drawer-Sections/5-Reports-Section/ReportsSection";
import GenFileButton from "./Drawer-Sections/6-Gen-File-Section/GenFileButton";
import AcadTemplateButton from "./Drawer-Sections/7-Design-ACAD-Section/AcadTemplateButton";
import EngineeringSection from "./Drawer-Sections/8-Engineering-Section/EngineeringSection";
import PackingSlipSection from "./Drawer-Sections/8-Engineering-Section/PackingSlip/PackingSlipSection";


const Drawer: React.FC = () => {

    const {user} = useCurrentUser();
    const {isLeftSidebarOpen} = useViewerStore();
    const setIsSidebar = (val: boolean) => useViewerStore.setState({isLeftSidebarOpen: val});

    return (
        user &&
        <>
            <AntDrawer
                open={isLeftSidebarOpen}
                onClose={() => setIsSidebar(false)}
                placement='left'
                closeIcon={
                    <Flex
                        justify={'center'}
                        align={'center'}
                        gap={5}
                        style={{
                            width: '200px',
                            paddingLeft: '30px',
                            cursor: 'pointer'
                        }}
                    ><XCircleIcon size={32}/>Close</Flex>
                }
                className={'left-drawer'}
            >

                <UserInfoSection/>

                <Divider/>

                <AddressInfoSection/>

                <Divider/>

                <DesignList/>

                <Divider/>

                <Flex justify={'center'} className='sidebar_buttons'>

                    <Flex vertical gap={20} style={{width: "90%"}}>

                        <CertificationSection/>

                        <Divider/>

                        <ReportsSection/>

                        <Divider/>

                        <GenFileButton/>

                        <Divider/>

                        <AcadTemplateButton/>

                        <Divider/>

                        <EngineeringSection/>

                        <PackingSlipSection/>

                    </Flex>

                </Flex>

            </AntDrawer>
        </>
    );
}

export default Drawer;
